module.exports = __webpack_public_path__ + "static/media/deepak_ji.215daec4.jpg";